<div class="Dialog" mat-dialog-content>
  <div>
    <p>The item you searched for was not found.</p>
  </div>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close] class="ThemeColorAccent">Ok</button>
  </mat-dialog-actions>
</div>